import { jsxs, jsx } from 'react/jsx-runtime';
import { LiveRegionIds } from './constants.mjs';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.mjs';

const LiveRegions = () => {
    return (jsxs(VisuallyHidden, { children: [jsx("p", { role: "log", "aria-live": "polite", id: LiveRegionIds.Log, "aria-relevant": "all" }), jsx("p", { role: "status", "aria-live": "polite", id: LiveRegionIds.Status, "aria-relevant": "all" }), jsx("p", { role: "alert", "aria-live": "assertive", id: LiveRegionIds.Alert, "aria-relevant": "all" })] }));
};

export { LiveRegions };
